import axios from 'axios';

// = = = = = = = = BASE URL = = = = = = =

const PORT = '7799';
const IS_LOCAL = false;

const getUrl = () => {
	if (IS_LOCAL) {
		return `http://localhost:${PORT}/api/`;
	}

	// Same-origin /api/ — CRA proxy (dev) and nginx on uae.maksimzaycev.ru (prod) forward to API.
	return '/api/';
};

// = = = = = = = = = = = = = = = = = = =

// Проверка наличия ключа
export const getToken = () => localStorage.getItem('property_authenticationToken');

// Сохранение ключа
export const setToken = (token: string) =>
	localStorage.setItem('property_authenticationToken', token);

// Удаление ключа
export const removeToken = () => localStorage.removeItem('property_authenticationToken');

// GET REQUEST
export const makeGetRequest = (entitySet, serviceUrl, params = {}, hasToken = false) => {
	const headers = {};
	const token = getToken();

	if (hasToken && !!token) {
		headers['Authorization'] = `Bearer ${token}`;
	}

	return axios.get(`${serviceUrl}${entitySet}`, {
		headers,
		params,
	});
};

// POST REQUEST
export const makePostRequest = (entitySet, serviceUrl, body = {}, hasToken = false) => {
	const headers = {};
	const token = getToken();

	if (hasToken && !!token) {
		headers['Authorization'] = `Bearer ${token}`;
	}

	return axios.post(`${serviceUrl}${entitySet}`, body, {
		headers,
	});
};

// DELETE REQUEST
export const makeDeleteRequest = (entitySet, serviceUrl, params = {}, hasToken = false) => {
	const headers = {};
	const token = getToken();

	if (hasToken && !!token) {
		headers['Authorization'] = `Bearer ${token}`;
	}

	return axios.delete(`${serviceUrl}${entitySet}`, {
		headers,
		data: params,
	});
};

// PUT REQUEST
export const makePutRequest = (entitySet, serviceUrl, params = {}, hasToken = false) => {
	const headers = {};
	const token = getToken();

	if (hasToken && !!token) {
		headers['Authorization'] = `Bearer ${token}`;
	}

	return axios.put(`${serviceUrl}${entitySet}`, {
		headers,
		params,
	});
};

export const getRequest = (entity, params = {}, hasToken = false) =>
	makeGetRequest(entity, getUrl(), params, hasToken);

export const postRequest = (entity, params = {}, hasToken = false) =>
	makePostRequest(entity, getUrl(), params, hasToken);

export const putRequest = (entity, params = {}, hasToken = false) =>
	makePutRequest(entity, getUrl(), params, hasToken);

export const deleteRequest = (entity, params = {}, hasToken = false) =>
	makeDeleteRequest(entity, getUrl(), params, hasToken);
